<mat-progress-bar class="" [ngClass]="[state,'mt-3', 'rounded-full']" [mode]="'determinate'"  [value]="value">
</mat-progress-bar>